import Icon from 'veui/components/Icon'

Icon.register({
  'image-add': {
    paths: [
      {
        d: 'M736 576a32 32 0 01-32 32h-96v96a32 32 0 01-64 0v-96h-96a32 32 0 010-64h96v-96a32 32 0 0164 0v96h96a32 32 0 0132 32zM704 96H64a32 32 0 00-32 32v512a32 32 0 0032 32h289a32 32 0 000-64H96v-18.75l160-160 73.37 73.38a32 32 0 0045.26 0L512 365.25l9.37 9.38a32 32 0 0045.26-45.26l-32-32a32 32 0 00-45.26 0L352 434.75l-73.37-73.38a32 32 0 00-45.26 0L96 498.75V160h576v224a32 32 0 0064 0V128a32 32 0 00-32-32zM256 247a40 40 0 1040-40 40 40 0 00-40 40z'
      }
    ],
    width: '768',
    height: '768'
  }
})
